import dashboardExecutiveService from "@services/dashboard/dashboardExecutiveService"
// `import type` là bắt buộc: interface được dùng trong chữ ký có decorator, và với
// isolatedModules + emitDecoratorMetadata thì import thường sẽ lỗi TS1272 (bẫy 23).
import type {
  IExecutiveSummary,
  IExecutiveTrendPoint,
  IProjectComparison,
} from "@services/dashboard/dashboardExecutiveService"
import { action, makeAutoObservable, observable } from "mobx"

/**
 * Store của Dashboard Ban lãnh đạo (Feature-0200). Mỗi widget có bộ ba `data*` / `loading*` / `error*`
 * riêng: trang load song song và một widget lỗi KHÔNG được kéo sập các widget khác (yêu cầu 4.1) —
 * giống `DashboardCsStore`, `DashboardFinanceStore` và `DashboardSalesStore`.
 */
class DashboardExecutiveStore {
  @observable dataSummary?: IExecutiveSummary
  @observable loadingSummary = false
  @observable errorSummary = false

  @observable dataProjectComparison?: IProjectComparison
  @observable loadingProjectComparison = false
  @observable errorProjectComparison = false

  @observable dataTrend?: IExecutiveTrendPoint[]
  @observable loadingTrend = false
  @observable errorTrend = false

  constructor() {
    makeAutoObservable(this)
  }

  @action
  getExecutiveSummary = async (
    params?: Record<string, unknown>
  ): Promise<void> => {
    this.loadingSummary = true
    this.errorSummary = false
    try {
      this.dataSummary =
        await dashboardExecutiveService.getExecutiveSummary(params)
    } catch {
      this.errorSummary = true
    } finally {
      this.loadingSummary = false
    }
  }

  @action
  getExecutiveTrend = async (
    params?: Record<string, unknown>
  ): Promise<void> => {
    this.loadingTrend = true
    this.errorTrend = false
    try {
      this.dataTrend = await dashboardExecutiveService.getExecutiveTrend(params)
    } catch {
      this.errorTrend = true
    } finally {
      this.loadingTrend = false
    }
  }

  @action
  getProjectComparison = async (
    params?: Record<string, unknown>
  ): Promise<void> => {
    this.loadingProjectComparison = true
    this.errorProjectComparison = false
    try {
      this.dataProjectComparison =
        await dashboardExecutiveService.getProjectComparison(params)
    } catch {
      this.errorProjectComparison = true
    } finally {
      this.loadingProjectComparison = false
    }
  }
}

export default DashboardExecutiveStore
